import styled from 'styled-components';
import { colors, device } from 'shared/defaultTheme';

export const ResetPasswordContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  overflow-y: unset;
`;

export const ResetPasswordWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 148px;
  width: 100%;
  @media ${device.sm} {
    margin-top: 30px;
  }

  .reset-password-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 76px;
    padding-left: 80px;
    padding-right: 80px;
    width: 32.34%;
    @media ${device.sm} {
      margin-top: 30px;
      padding-left: 0;
      padding-right: 0;
      width: 93%;
    }
  }

  .form__form-group-field--error {
    background-color: transparent !important;
    input {
      color: ${colors.error} !important;
    }
  }

  .helper-text {
    color: ${colors.suvaGrey};
    font-size: 12px;
    line-height: 15px;
  }

  .submit-button {
    font-size: 14px;
    width: 345px;
    height: 40px;
    margin-top: 46px;
    @media ${device.sm} {
      width: 100%;
    }
  }
`;

export const ResetPasswordTitle = styled.h1`
  color: ${colors.black};
  font-family: MTTMilano;
  font-size: 50px;
  letter-spacing: 0;
  line-height: 60px;
  @media ${device.sm} {
    font-size: 32px;
  }
`;
